import { render } from "./LootBoxApe.vue?vue&type=template&id=16f3cf4d"
import script from "./LootBoxApe.vue?vue&type=script&lang=js"
export * from "./LootBoxApe.vue?vue&type=script&lang=js"

import "./LootBoxApe.vue?vue&type=style&index=0&id=16f3cf4d&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__